import { OutlinedCard, Row, StatColumn, Text, Link } from "@bridgesplit/ui";
import { BsMetaUtil, RoleView } from "@bridgesplit/abf-react";
import { bsMath, formatUsd } from "@bridgesplit/utils";
import { StrategyDuration } from "@bridgesplit/abf-sdk";

import { MarketStats } from "./types";
import { BorrowCapWarning, getMarketPath, TokenImage } from "../../common";
import MarketDetailCta from "./MarketDetailCta";
import { NetBorrowApy, NetLendApy } from "./common";
export default function PrincipalMarketCard({
    marketStats,
    selectedDuration,
    view
}: {
    marketStats: MarketStats | undefined;
    selectedDuration: StrategyDuration | undefined;
    view: RoleView;
}) {
    const metadata = marketStats?.metadata;

    return (
        <Link to={getMarketPath({ token: metadata, view: undefined })}>
            <OutlinedCard padding={2} spacing={3}>
                <Row spacing={1}>
                    <TokenImage metadata={metadata} size="lg" />

                    <Text loading={!marketStats} variant="h3" fontWeight="normal">
                        {BsMetaUtil.getSymbolUnique(metadata)}
                    </Text>
                </Row>
                <StatColumn
                    loading={!marketStats || !selectedDuration}
                    stats={[
                        {
                            caption: view === RoleView.Borrow ? "Net Borrow APY" : "Avg. Lend APY",
                            value: <RewardsMobileApy marketStats={marketStats} view={view} />
                        },
                        {
                            caption: "Supplied",
                            value: bsMath.add(marketStats?.availableUsd, marketStats?.borrowedUsd),
                            isUsd: true
                        },
                        {
                            caption: "Borrowed",
                            value: marketStats?.borrowCapWarning ? (
                                <BorrowCapWarning borrowCapWarning={marketStats.borrowCapWarning}>
                                    {formatUsd(marketStats?.borrowedUsd)}
                                </BorrowCapWarning>
                            ) : (
                                marketStats?.borrowedUsd
                            ),
                            isUsd: true
                        }
                    ]}
                />
                <MarketDetailCta isMobile view={view} token={metadata} />
            </OutlinedCard>
        </Link>
    );
}

function RewardsMobileApy({ marketStats, view }: { marketStats: MarketStats | undefined; view: RoleView }) {
    if (view === RoleView.Borrow) {
        return <NetBorrowApy data={marketStats} />;
    }
    return <NetLendApy data={marketStats} />;
}
